import styled, { css } from 'styled-components/macro';
import { Table } from '~/components';
import TableLegend from './components/TableLegend';

export const Container = styled.div`
  padding: 32px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 32px 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: ${({ isLocal }) => (isLocal ? 'row' : 'row-reverse')};
  padding: 5px 0;
  font-size: 13px;
  font-family: ${({ theme }) => theme.primaryFontBold};
  text-align: center;
  color: ${({ theme, isLocal }) => (isLocal ? theme.dark : theme.white)};
  svg {
    margin-right: 5px;
  }
  span {
    font-family: ${({ theme }) => theme.primaryFontBold};
    font-size: ${({ theme }) => theme.h5}px;
    margin-right: 5px;
  }
`;

export const Title = styled.span`
  text-transform: uppercase;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding-bottom: 10px;
    position: relative;
    margin-bottom: 20px;
    &:before {
      content: '';
      position: absolute;
      width: 80%;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      height: 2px;
      border-bottom: solid 2px;
    }
  }
`;

export const StatsTable = styled(Table)`
  margin-top: 38px;
  table {
    thead {
      th {
        font-family: ${({ theme }) => theme.primaryFont};
        text-transform: uppercase;
        position: sticky;
        top: 42px;
        background-color: ${({ theme, isLocal }) =>
          isLocal ? theme.white : theme.dark4};
        @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
          position: relative;
          top: 0;
        }
        div {
          display: flex;
          justify-content: center;
        }
        &:first-child {
          font-family: ${({ theme }) => theme.primaryFontBold};
        }
        &:nth-child(2n) {
          font-family: ${({ theme }) => theme.primaryFontBold};
        }
      }

      th:first-child {
        div {
          font-size: ${({ theme }) => theme.h5}px;
          justify-content: flex-start;
        }
      }
    }
    tfoot tr {
    }
    tbody tr {
      ${({ rowsThatHaveTop }) => {
        return css`
          ${rowsThatHaveTop}
        `;
      }}
    }
    tbody tr td {
      font-family: ${({ theme }) => theme.primaryFont};
      div {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(2n) {
        font-family: ${({ theme }) => theme.primaryFontBold};
      }
    }
    tbody tr td:first-child {
      div {
        justify-content: flex-start;
      }
    }
  }
`;

export const PlayerName = styled.p`
  text-transform: uppercase;
`;

export const Bold = styled.span`
  font-family: ${({ theme }) => theme.primaryFontBold};
  margin-right: 5px;
`;

export const TableLegendFooter = styled(TableLegend)`
  margin-top: 27px;
  margin-bottom: 27px;
  color: ${({ theme, isLocal }) => (isLocal ? theme.dark : theme.white)};
`;
